import React from 'react'
import Link from './Link'
import Image from './Image'
import Headline from './Headline'

const StackedTeaser = ({ item, className }) => {
  return (
    <section className={`stacked-teaser-item ${className}`}>
      <article>
        <Link link={item.link}>
          <div className="teaser-item-image">
            <Image
              className="img-fluid"
              image={item.image}
              alt={item.alt}
              title={item.alt}
            />
          </div>
          <div className="teaser-item-content">
            <Headline headline={item.headline} />
            <p className="teaser-item-text">{item.text}</p>
            <span className="pseudo-link">{item.link_text}</span>
            <div className="meta-info">{item.meta_info}</div>
          </div>
        </Link>
      </article>
    </section>
  )
}

export default StackedTeaser
